import React from "react";
import ReactApexChart from "react-apexcharts";

class LineChart extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      chartData: props.lineChartData || [],
      chartOptions: props.lineChartOptions || {},
    };
  }

  componentDidUpdate(prevProps) {
    
    if (this.props.lineChartData !== prevProps.lineChartData) {
      
      this.setState({ chartData: this.props.lineChartData });
    }
    if (this.props.lineChartOptions !== prevProps.lineChartOptions) {
      
      this.setState({ chartOptions: this.props.lineChartOptions });
    }
  }

  
    render() {
    // Adicionando uma verificação de segurança extra antes de renderizar
    if (!this.state.chartData || !Array.isArray(this.state.chartData)) {
        console.error("[5f] LineChart: chartData não é um array válido!", this.state.chartData);
        return <div>Erro ao carregar dados do gráfico.</div>;
    }
    return (
      <ReactApexChart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="area"
        width="100%"
        height="100%"
      />
    );
  }
}

export default LineChart;